import * as React from 'react';
import { makeIcon } from './makeIcon';
const ArrowReturn = props => (React.createElement("svg", Object.assign({ width: '16px', height: '16px', viewBox: '0 0 16 16' }, props),
    React.createElement("path", { "fill-rule": 'evenodd', "clip-rule": 'evenodd', d: 'M16 0V8C16 10.444 13.9996 12.4444 11.5556 12.4444H4.44444V16L0 11.5556L4.44444 7.11111V10.6667H11.5556C13.0387 10.6667 14.2222 9.4831 14.2222 8V0H16Z' })));
export const ArrowReturnIcon = makeIcon('arrowReturn')(ArrowReturn);
//# sourceMappingURL=ArrowReturn.js.map